import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import axios from 'axios';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Stil dosyası
import { useTranslation } from 'react-i18next';


const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

const AddTopicModal = ({ open, onClose, refreshTopics }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const { t } = useTranslation();

  const handleSubmit = async () => {
    const token = localStorage.getItem('token');
    try {
      await api.post(
        "/api/forum/topics",
        { title, content },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      refreshTopics(); // Başlıkları yeniden yükler
      await api.get("/api/sitemap/generate");
      onClose();
    } catch (error) {
    }
  };

  return (
<Dialog open={open} onClose={onClose}>
  <DialogTitle>{t('new_topic')}</DialogTitle>
  <DialogContent>
    <TextField
      fullWidth
      margin="dense"
      placeholder={t('topic_title')}
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />
    <ReactQuill
      value={content}
      onChange={setContent}
      placeholder={t('topic_placeholder')}
      style={{ marginTop: "10px", minHeight: "200px" }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={onClose} color="secondary">
      {t('cancel')}
    </Button>
    <Button onClick={handleSubmit} color="primary">
      {t('submit')}
    </Button>
  </DialogActions>
</Dialog>
  );
};

export default AddTopicModal;
